import React from "react";
import LearningContentVideoPlayer from "./LearningContentVideoPlayer";

const StudentLearningContentRenderer = ({ blocks, mediaUrls }) => (
  <div className="slc-block-list" aria-label="Learning Content">
    {blocks.map((block) => {
      if (block.type === "heading") {
        const Heading = block.level === 3 ? "h3" : "h2";
        return (
          <section className="slc-block slc-heading-block" key={block.id} data-block-id={block.id}>
            <Heading>{block.text}</Heading>
          </section>
        );
      }
      if (block.type === "text") {
        return (
          <section className="slc-block slc-text-block" key={block.id} data-block-id={block.id}>
            <p>{block.text}</p>
          </section>
        );
      }
      if (block.type === "link") {
        return (
          <section className="slc-block slc-link-block" key={block.id} data-block-id={block.id}>
            <a href={block.url} target="_blank" rel="noopener noreferrer">
              <span>{block.label}</span>
              <span aria-hidden="true">↗</span>
            </a>
          </section>
        );
      }
      if (block.type === "video") {
        return (
          <section className="slc-block slc-video-block" key={block.id} data-block-id={block.id}>
            <LearningContentVideoPlayer block={block} />
          </section>
        );
      }
      if (block.type === "image") {
        return (
          <figure className="slc-block slc-image-block" key={block.id} data-block-id={block.id}>
            <img src={mediaUrls[block.id]} alt={block.altText} />
            {block.caption && <figcaption>{block.caption}</figcaption>}
          </figure>
        );
      }
      if (block.type === "resource") {
        return (
          <section className="slc-block slc-resource-block" key={block.id} data-block-id={block.id}>
            <div className="slc-resource-icon" aria-hidden="true">PDF</div>
            <div>
              <p className="slc-resource-label">{block.label}</p>
              <p className="slc-resource-help">Opens securely in a new tab</p>
            </div>
            <a href={mediaUrls[block.id]} target="_blank" rel="noopener noreferrer">
              Open PDF
            </a>
          </section>
        );
      }
      return null;
    })}
  </div>
);

export default StudentLearningContentRenderer;
